import { isEoeOrPunchout } from '../common/constants/pathVariables.js';
import { findCatalogById } from '../common/utils/catalogUtils.js';
import { isInBrowser } from '../common/utils/ssrUtils.js';
import { getSessionData } from '../public/site/sessionDataStore.js';
import {
  catalogToValidationRules,
  dispatchAuthAction,
  eppSolutionToValidationRules,
  postProcessCartItems,
} from './actions/index.js';
import { ACTIVE_ACCOUNT_MASTER_ID_LOCAL_STORAGE_KEY } from './common/localStorageUtils.js';
import type { State } from './common/store.js';
import type { Store } from 'redux';

const CART_ITEMS_LOCAL_STORAGE_KEY = 'ngStorage-cartItems-default';

export const initializeShoppingCart = (store: Store<State>): void => {
  const isEmployee = isEoeOrPunchout(location.pathname);

  if (isInBrowser()) {
    window.addEventListener('storage', event => {
      if (event.key === CART_ITEMS_LOCAL_STORAGE_KEY) {
        const state = store.getState();
        const selectedCatalog = findCatalogById(
          state.selfservice?.virtualCatalogs?.items,
          state.selfservice?.virtualCatalogs?.selectedCatalogCode
        );

        const validationRules = isEmployee
          ? catalogToValidationRules(selectedCatalog)
          : eppSolutionToValidationRules(getSessionData().companyInfo?.eppSolution);

        store.dispatch(
          postProcessCartItems(
            true,
            isEmployee,
            event.newValue || '[]',
            validationRules,
            undefined,
            undefined,
            undefined,
            true
          )
        );
      }
    });
  }
};

export const initializeActiveAccountChangeListener = (): void => {
  if (isInBrowser()) {
    window.addEventListener('storage', event => {
      if (event.key === ACTIVE_ACCOUNT_MASTER_ID_LOCAL_STORAGE_KEY && event.newValue) {
        dispatchAuthAction('SET_ACTIVE_ACCOUNT', event.newValue);
      }
    });
  }
};
